<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay :retain-focus="false" persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" x-medium large block rounded color="primary" dark>
                {{ $t('suppliers.label.addSupplier.title') }}
            </v-btn>
        </template>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-btn icon dark class="btn btn-primary" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-toolbar-title>{{ $t('suppliers.label.addSupplier.title') }}</v-toolbar-title>

                <template v-slot:extension>
                    <v-tabs v-model="tab" align-with-title>
                        <v-tabs-slider color="accent"></v-tabs-slider>

                        <v-tab v-for="item in items" :key="item">
                            {{ item }}
                        </v-tab>
                    </v-tabs>
                </template>

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">

                <v-tab-item>
                    <div class="container mt-4">
                        <addSuppliers />
                    </div>
                </v-tab-item>

            </v-tabs-items>

        </v-card>
    </v-dialog>

</template>

<script>

import addSuppliers from '@/views/suppliers/pages/add_suppliers/components/form_add_suppliers_component.vue';
import EventBus from '@/utils/event_bus.js';

export default {

    name: "suppliersPage",
    components: {
        addSuppliers,
    },
    data() {
        return {
            dialog: false,
            tab: null,
            items: [
                this.$t('label.tab')
            ],
        }
    },
    watch: {
        dialog(newVal) {
            // Cuando el diálogo se cierra, emitir evento para limpiar el formulario
            if (!newVal) {
                EventBus.$emit('clear-suppliers-form');
            }
        }
    },
    async mounted() {
        EventBus.$on('formSuppliers-submitted-successfully', () => {
            this.closeDialog()
            EventBus.$emit('reload-suppliers');
        });
    },

    methods: {
        closeDialog() {
            this.$store.commit('RESET_STATE');
            this.dialog = false;
            window.location.reload();

        },
    },
};
</script>